// extracted by mini-css-extract-plugin
export default {"listTitle":"VendorsList_listTitle__fbzx4"};